module.exports = __webpack_public_path__ + "img/fist-gilgamesh.f79c5b52.jpg";